module.exports = __webpack_public_path__ + "static/media/INZ1183.99fa6959.pdf";